import React from 'react';
import CountryItem from '../Domain/CountryItem';
import CountryItemForAdmin from '../Domain/CountryItemForAdmin';
import AuthService from './authService.js';
import SearchParams from '../Elements/SearchParams';
import CountrySearchParams from '../Contents/Countries/CountryAdmin/CountrySearchParams';

export default class CountryService extends React.Component {
  static async GetCountryList() {
    return AuthService.getInstance().CallBackendFunction('/api/Country/GetCountries/?clearCache=false');
  }

  static async GetCountriesOffices() {
    return CountryService.ConvertAllDBCountry(
      await AuthService.getInstance().CallBackendFunction('/api/Country/GetCountriesOffices/?clearCache=false')
    );
  }

  static async GetAllCountryList(link) {
    return AuthService.getInstance().CallBackendFunction(link);
  }

  static GetAllCountryBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    searchItem.SelectedOfficeIds = searchItem.SelectedOfficeIds.toString();
    searchItem.SelectedEvaluatorOfficeIds = searchItem.SelectedEvaluatorOfficeIds.toString();
    const searchParams = new SearchParams(searchItem, CountrySearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/Country/GetAllCountries/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return CountryService.GetAllCountryList(url);
  }

  static GetAllCountryByCode(CountryCode) {
    const url = `/api/Country/GetCountryByCountryCode/?CountryCode=${CountryCode}&clearCache=false`;

    return CountryService.GetAllCountryList(url);
  }

  static GetCountryById(id) {
    const url = `/api/Country/GetCountryById/?CountryId=${id}&clearCache=false`;

    return CountryService.GetAllCountryList(url);
  }

  static async GetCountryNameById(id) {
    const url = `/api/Country/GetCountryNameByIdAsync/${id}?clearCache=false`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static UpsertCountry(country) {
    country = CountryService.ConvertAllPropertyToString(country);

    const countryJSON = JSON.stringify(country);

    if (country.CountryId === '')
      return AuthService.getInstance().CallBackendFunctionPost('/api/Country/AddCountry', countryJSON);

    return AuthService.getInstance().CallBackendFunctionPut('/api/Country/EditCountry', countryJSON);
  }

  static DownloadCountryListDetailsInExcel(filter) {
    filter.SelectedOfficeIds = filter.SelectedOfficeIds.toString();
    filter.SelectedEvaluatorOfficeIds = filter.SelectedEvaluatorOfficeIds.toString();
    const searchParams = new SearchParams(filter, CountrySearchParams, '', '', 0, 0);
    const url = `/api/Country/DownloadInExcel/?searchParams=${searchParams.serializeForBackendCall()}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBCountry(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new CountryItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static ConvertAllDBCountry(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new CountryItemForAdmin(item);
        convertedItems.push(newItem);
      });
    }
    return convertedItems;
  }

  static ConvertAllPropertyToString(country) {
    for (const key in country) {
      if (Object.hasOwnProperty.call(country, key)) {
        country[key] = country[key] ? country[key].toString() : '';
      }
    }
    return country;
  }
}

